import {environment} from "../../../environments/environment";
import {ApiService} from "@libs/axios";
import NotificationService from "@common/services/notification.service";
import AuthService from "../../auth/services/auth.service";
import ErrorHandling from "./error-handling";

export class AppApiService extends ApiService {
    constructor() {
        super({
            baseUrl: environment.backendUrl,
            notificationService: {
                success: NotificationService.success.bind(NotificationService),
                error: NotificationService.error.bind(NotificationService),
            },
            authService: {
                getToken: () => AuthService.getAuthToken
            },
            errorHandlingService: ErrorHandling,
        });
    }
}
